export const allOrders = [
	"Afrosoricida",
	"Artiodactyla",
	"Carnivora",
	"Chiroptera",
	"Cingulata",
	"Dasyuromorphia",
	"Dermoptera",
	"Didelphimorphia",
	"Diprotodontia",
	"Eulipotyphla",
	"Hyracoidea",
	"Lagomorpha",
	"Macroscelidea",
	"Microbiotheria",
	"Monotremata",
	"Notoryctemorphia",
	"Paucituberculata",
	"Peramelemorphia",
	"Perissodactyla",
	"Pholidota",
	"Pilosa",
	"Platanistidae",
	"Primates",
	"Proboscidea",
	"Rodentia",
	"Scandentia",
	"Sirenia",
	"Tubulidentata",
];
export const allRisk = { "Level 5": "5", "Level 4": "4", "Level 3": "3", "Level 2": "2", "Level 1": "1" };
export const allHabitats = [
	"Artificial Aquatic",
	"Artificial Terrestrial",
	"Caves",
	"Desert",
	"Forest",
	"Grassland",
	"Introduced Vegetation",
	"Marine Coastal",
	"Marine Intertidal",
	"Marine Neritic",
	"Marine Oceanic",
	"Rocky Areas",
	"Savanna",
	"Shrubland",
	"Wetlands",
];
